import { render, staticRenderFns } from "./InactiveCountryWarning.vue?vue&type=template&id=5b7be20b&"
import script from "./InactiveCountryWarning.vue?vue&type=script&lang=js&"
export * from "./InactiveCountryWarning.vue?vue&type=script&lang=js&"
import style0 from "./InactiveCountryWarning.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports